import * as React from 'react';
import './SupportImageViewer.css';

export default class SupportImageViewer extends React.Component<any, any> {
  render() {
    return (
      <div className="image-viewer-box">
        <h2>Image Viewer</h2>
        <h3>The image viewing area</h3>
        <p>
          The image viewing area displays the record selected to view. The image viewer tools are in the top left-hand corner and can be used to zoom in and out, return to original view, enter full screen mode, rotate left and right, navigate to previous and next pages of the record and print (not available to all collections).
        </p>
        <p>
          <img src="screenshots/print-navigation.png" alt="Print Buttons"/>
        </p>
        <p>
          Panning is accomplished by clicking on the image and dragging it. Zooming can also be achieved by scrolling.
        </p>
        <p>
          The image pane in the top right of the image viewing area indicates in a red rectangle, the extent being viewed when zoomed in.
        </p>
        <p>
          Where a record consists of multiple pages, the image pagination tool <img style={{verticalAlign:'middle'}} src="screenshots/image-pagination-tool.png" alt="Image Pagination Tool"/> in the bottom right of the viewer can be used to jump to the desired image.
        </p>
        <p>
          In the bottom left of the viewer <img style={{verticalAlign:'middle'}} src="screenshots/show-image-metadata-btn.png" alt="Show Image Metadata"/> can be selected to view the metadata held for the image. The metadata held against images in each collection will vary.
        </p>
        <br/>

        <h3>Print and Save</h3>
        <p>
          Print and Save in the HLRV is available to limited collections.
        </p>
        <br/>
        <p>To print and/or save a copy of a record:</p>
        <ol>
          <li>1. Click on the print button in the toolbar</li>
          <li>2. Select the required paper size and quality</li>
          <li>3. Press the print button</li>
          <li>4. Once the image is displayed in a new browser, select print or download as desired</li>
        </ol>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SupportImageViewer.tsx